export default "__VITE_ASSET__DXX01uIT__"